/**
 * 账户类型
 *
 * 个人用户（中国）：10
 * 企业用户（中国）：20
 * 企业用户（印尼）：21
 * 企业用户（中国香港）：22
 * 服务商（中国）： 30
 */
export enum AccountType {
    Default = 0,
    PersonalZH = 10,
    EnterpriseZH = 20,
    EnterpriseID = 21,
    EnterpriseHK = 22,
    ProviderZH = 30,
}

export const ACCOUNT_TYPE_NAMES = Object.freeze({
    [AccountType.PersonalZH]: 'account.title.personal_zh',
    [AccountType.EnterpriseZH]: 'account.title.enterprise_zh',
    [AccountType.EnterpriseID]: 'account.title.enterprise_id',
    [AccountType.EnterpriseHK]: 'account.title.enterprise_hk',
    [AccountType.ProviderZH]: 'account.title.provider_zh',
});
